"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WsSelectionPopup = void 0;
var react_1 = __importStar(require("react"));
var react_dom_1 = require("react-dom");
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
require("./styles/selection-popup.scss");
var TYPE_OPTIONS = [
    { key: 'metric', text: 'Metric' },
    { key: 'pain', text: 'Pain Point' },
    { key: 'benefit', text: 'Benefit' },
    { key: 'risk', text: 'Risk' },
    { key: 'persona', text: 'Persona' },
    { key: 'tech', text: 'Technology' },
    { key: 'data', text: 'Data Source' },
    { key: 'integration', text: 'Integration' },
    { key: 'budget', text: 'Budget Item' },
    { key: 'roadmap', text: 'Roadmap Item' },
];
var POPUP_WIDTH_FALLBACK = 320;
var POPUP_HEIGHT_ESTIMATE = 320;
var VIEWPORT_PADDING = 12;
var POPUP_VERTICAL_OFFSET = 40;
var getVisualViewport = function () {
    return window.visualViewport;
};
var usePopupDismissHandlers = function (popupRef, onDismiss) {
    var handleClickOutside = react_1.useCallback(function (event) {
        var node = popupRef.current;
        if (!(event.target instanceof Node)) {
            return;
        }
        var clickedInsideDropdownCallout = event.target instanceof Element &&
            Boolean(event.target.closest('.ms-Callout, .ms-Layer, .ms-Dropdown-items'));
        if (node && !node.contains(event.target) && !clickedInsideDropdownCallout) {
            onDismiss();
        }
    }, [onDismiss, popupRef]);
    var handleKeydown = react_1.useCallback(function (event) {
        if (event.key === 'Escape') {
            onDismiss();
        }
    }, [onDismiss]);
    react_1.useEffect(function () {
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleKeydown);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleKeydown);
        };
    }, [handleClickOutside, handleKeydown]);
};
/**
 * Floating popup anchored at the user's text selection. Lets them
 * tag the snippet as a metric, pain, persona etc and persist a new
 * `ElementMention` (and possibly a new `Element`) on the backend.
 */
var WsSelectionPopup = function (props) {
    var anchor = props.anchor, isSubmitting = props.isSubmitting, onSubmit = props.onSubmit, onDismiss = props.onDismiss;
    var _a = react_1.useState('metric'), elementType = _a[0], setElementType = _a[1];
    var _b = react_1.useState(anchor.text.trim().slice(0, 200)), canonicalName = _b[0], setCanonicalName = _b[1];
    var _c = react_1.useState(''), description = _c[0], setDescription = _c[1];
    var _d = react_1.useState({
        left: anchor.x,
        top: anchor.y,
    }), position = _d[0], setPosition = _d[1];
    var popupRef = react_1.useRef(null);
    // Reset the form when a new selection anchor arrives.
    react_1.useEffect(function () {
        setCanonicalName(anchor.text.trim().slice(0, 200));
        setDescription('');
        setElementType('metric');
    }, [anchor.section, anchor.text]);
    // Dismiss on outside click or Escape — keeps the popup feeling like
    // a tooltip rather than a modal.
    usePopupDismissHandlers(popupRef, onDismiss);
    var updatePosition = react_1.useCallback(function () {
        var _a, _b, _c, _d, _e, _f;
        var popupNode = popupRef.current;
        var popupRect = popupNode === null || popupNode === void 0 ? void 0 : popupNode.getBoundingClientRect();
        var popupWidth = (_a = popupRect === null || popupRect === void 0 ? void 0 : popupRect.width) !== null && _a !== void 0 ? _a : POPUP_WIDTH_FALLBACK;
        var popupHeight = (_b = popupRect === null || popupRect === void 0 ? void 0 : popupRect.height) !== null && _b !== void 0 ? _b : POPUP_HEIGHT_ESTIMATE;
        var visualViewport = getVisualViewport();
        var viewportLeft = (_c = visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.offsetLeft) !== null && _c !== void 0 ? _c : 0;
        var viewportTop = (_d = visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.offsetTop) !== null && _d !== void 0 ? _d : 0;
        var viewportWidth = (_e = visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.width) !== null && _e !== void 0 ? _e : window.innerWidth;
        var viewportHeight = (_f = visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.height) !== null && _f !== void 0 ? _f : window.innerHeight;
        var minLeft = viewportLeft + VIEWPORT_PADDING;
        var minTop = viewportTop + VIEWPORT_PADDING;
        var maxLeft = Math.max(minLeft, viewportLeft + viewportWidth - popupWidth - VIEWPORT_PADDING);
        var maxTop = Math.max(minTop, viewportTop + viewportHeight - popupHeight - VIEWPORT_PADDING - POPUP_VERTICAL_OFFSET);
        var left = Math.min(Math.max(anchor.x, minLeft), maxLeft);
        var baseTop = Math.min(Math.max(anchor.y, minTop), maxTop);
        var top = Math.min(Math.max(baseTop - POPUP_VERTICAL_OFFSET, minTop), maxTop);
        setPosition(function (prev) {
            if (prev.left === left && prev.top === top) {
                return prev;
            }
            return { left: left, top: top };
        });
    }, [anchor.x, anchor.y]);
    react_1.useLayoutEffect(function () {
        updatePosition();
        var popupNode = popupRef.current;
        var resizeObserver = typeof ResizeObserver !== 'undefined' && popupNode
            ? new ResizeObserver(function () {
                updatePosition();
            })
            : null;
        if (popupNode && resizeObserver) {
            resizeObserver.observe(popupNode);
        }
        var visualViewport = getVisualViewport();
        window.addEventListener('resize', updatePosition);
        visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.addEventListener('resize', updatePosition);
        visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.addEventListener('scroll', updatePosition);
        return function () {
            window.removeEventListener('resize', updatePosition);
            visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.removeEventListener('resize', updatePosition);
            visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.removeEventListener('scroll', updatePosition);
            if (resizeObserver) {
                resizeObserver.disconnect();
            }
        };
    }, [updatePosition]);
    var dropdownOptions = TYPE_OPTIONS.map(function (opt) { return ({
        key: opt.key,
        text: opt.text,
    }); });
    var handleSave = function () {
        var trimmedName = canonicalName.trim();
        if (!trimmedName) {
            return;
        }
        onSubmit({
            elementType: elementType,
            canonicalName: trimmedName,
            description: description.trim() ? description.trim() : undefined,
        });
    };
    var isSaveDisabled = isSubmitting || canonicalName.trim().length === 0;
    var popup = (react_1.default.createElement("div", { ref: popupRef, className: "ws-ai-hub-selection-popup", style: position, onMouseDown: function (event) { return event.stopPropagation(); } },
        react_1.default.createElement("div", { className: "ws-ai-hub-selection-popup-header" },
            react_1.default.createElement("span", { className: "ws-ai-hub-selection-popup-title" }, "Add element"),
            react_1.default.createElement("button", { type: "button", className: "ws-ai-hub-selection-popup-close", onClick: onDismiss, "aria-label": "Close" }, "\u00D7")),
        react_1.default.createElement("div", { className: "ws-ai-hub-selection-popup-snippet" }, anchor.text),
        react_1.default.createElement("div", { className: "ws-ai-hub-selection-popup-field" },
            react_1.default.createElement(office_ui_fabric_react_1.Dropdown, { label: "Type", selectedKey: elementType, options: dropdownOptions, disabled: isSubmitting, onChange: function (_event, option) {
                    if (option) {
                        setElementType(option.key);
                    }
                } })),
        react_1.default.createElement("div", { className: "ws-ai-hub-selection-popup-field" },
            react_1.default.createElement("label", { htmlFor: "ws-ai-hub-selection-popup-name" }, "Name"),
            react_1.default.createElement("input", { id: "ws-ai-hub-selection-popup-name", type: "text", value: canonicalName, maxLength: 200, disabled: isSubmitting, onChange: function (event) { return setCanonicalName(event.target.value); } })),
        react_1.default.createElement("div", { className: "ws-ai-hub-selection-popup-field" },
            react_1.default.createElement("label", { htmlFor: "ws-ai-hub-selection-popup-desc" }, "Description (optional)"),
            react_1.default.createElement("textarea", { id: "ws-ai-hub-selection-popup-desc", value: description, maxLength: 4000, disabled: isSubmitting, onChange: function (event) { return setDescription(event.target.value); } })),
        react_1.default.createElement("div", { className: "ws-ai-hub-selection-popup-actions" },
            react_1.default.createElement(office_ui_fabric_react_1.DefaultButton, { text: "Cancel", onClick: onDismiss, disabled: isSubmitting }),
            react_1.default.createElement(office_ui_fabric_react_1.PrimaryButton, { text: isSubmitting ? 'Saving...' : 'Add', onClick: handleSave, disabled: isSaveDisabled }))));
    if (typeof document === 'undefined') {
        return popup;
    }
    return react_dom_1.createPortal(popup, document.body);
};
exports.WsSelectionPopup = WsSelectionPopup;
